import { getTimezone } from "@/lib/timezone";

import type { LabOrderFetchParams } from "@/types/lab";

import { createLabOrderFilterDefinitions } from "@/features/lab/filter-definitions";
import { serializeFilterQuerySegments } from "@/features/table-filters/contract";

// Serialization only reads each definition's wire-key/policy metadata, never
// `options` (that's presentation-only) — so empty labs/providers here reuse
// filter-definitions.ts's key mapping instead of a second, driftable copy of it.
const labOrderFilterDefinitions = createLabOrderFilterDefinitions({
  labs: [],
  providers: [],
});

function appendScalar(
  params: URLSearchParams,
  key: string,
  value: unknown,
): void {
  if (value === undefined || value === null || value === "") return;
  params.append(key, String(value));
}

export function labOrderFiltersToSearchParams(
  filters: LabOrderFetchParams = {},
): URLSearchParams {
  const params = serializeFilterQuerySegments([
    { definitions: labOrderFilterDefinitions, values: filters },
  ]);
  appendScalar(params, "page", filters.page);
  appendScalar(params, "per_page", filters.perPage);
  appendScalar(params, "sort_by", filters.sortBy);
  appendScalar(params, "sort_direction", filters.sortDirection);
  // Widens the created-date range to absolute day boundaries server-side —
  // always sent, not gated on the date filter being active.
  appendScalar(params, "tz", filters.tz ?? getTimezone());
  return params;
}
